import Enums from 'utils/EnumsManager';
import {
  SET_META_DATA_FIELDS,
  SET_META_CONDITIONS,
  SET_META_CONTEXT,
  SET_SIDER,
  RESET_SIDER,
  SET_TRIGGER_META_OBJECT_OPTIONS,
  SET_META_FIELDS_DATA,
  RESET_META_DATA
} from '../actionTypes';

const { WorkFlow, ObjectTypes } = Enums;
const { UpdateFields } = WorkFlow;
const { Leads, Accounts, Opportunities } = ObjectTypes;

const initialMetaData = {
  sider: {
    displayNum: '',
    value: '',
    options: [],
  },
  ruleMetaData: {
    context: [],
  },
  criteriaMetaData: {
    fields: [],
    conditions: {},
  },
  triggerMeta: {
    triggerTypes: [
      {
        value: UpdateFields,
        display_label: 'Update Fields'
      }
    ],
    objectOptions: [],
    fieldsData: {
      [Leads]: [],
      [Accounts]: [],
      [Opportunities]: [],
    },
  },
};

const metaData = (state = initialMetaData, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_META_CONTEXT:
      const { metaContext } = payload;
      return {
        ...state,
        ruleMetaData: {
          ...state.ruleMetaData,
          context: metaContext,
        }
      };

    case SET_META_DATA_FIELDS:
      const { metaDataFields } = payload;
      return {
        ...state,
        criteriaMetaData: {
          ...state.criteriaMetaData,
          fields: metaDataFields
        }
      };

    case SET_META_CONDITIONS:
      const { metaConditions } = payload;
      return {
        ...state,
        criteriaMetaData: {
          ...state.criteriaMetaData,
          conditions: metaConditions
        }
      };

    case SET_SIDER:
      const { siderOptions, selectedcriteria, sessionNum } = payload;
      return {
        ...state,
        sider: {
          sessionNum,
          displayNum: selectedcriteria.displayNum,
          value: selectedcriteria.value,
          options: siderOptions,
        }
      };

    case RESET_SIDER:
      return {
        ...state,
        sider: initialMetaData.sider
      };

    case SET_TRIGGER_META_OBJECT_OPTIONS:
      const { objectOptions } = payload;
      return {
        ...state,
        triggerMeta: {
          ...state.triggerMeta,
          objectOptions
        }
      };

    case SET_META_FIELDS_DATA:
      const { fields, objectTypes } = payload;
      return {
        ...state,
        triggerMeta: {
          ...state.triggerMeta,
          fieldsData: {
            ...state.triggerMeta.fieldsData,
            [objectTypes]: fields
          }
        }
      };

    case RESET_META_DATA:
      return {
        ...state,
        sider: initialMetaData.sider,
        triggerMeta: initialMetaData.triggerMeta,
      };

    default:
      return state;
  }
};

export default metaData;



// WEBPACK FOOTER //
// ./src/views/Setup/WorkFlow/flow/reducers/metaData.js